import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import withoutNulls from '../../../../api/search/withoutNulls';

const buildQuery = (modelType: Costs.ModelType) => ({
  query: gql`
    query getCostModel($modelType: CostModelType!) {
      getCostModel(modelType: $modelType) {
        id
        modelType
        groupFieldName
        groups {
          groupName
          fields
        }
        interval
        startOfWeek
        dateField
        startDate
        categories {
          costFieldName
          costValueType
        }
        activityCostCalculationMode
        isDraft
        marginExcludeFSC
        marginExcludePassThru
      }
    }
  `,
  variables: {
    modelType,
  },
});

const getCostModel = async (
  modelType: Costs.ModelType,
  client: ApolloClient<NormalizedCacheObject>,
): Promise<Costs.PersistedCostModel[]> => {
  const gqlQuery = buildQuery(modelType);
  const response = await client.query(gqlQuery);
  return withoutNulls(response.data.getCostModel);
};

export default getCostModel;
